import React from 'react';

export function FileExport({ color }: { color: 'blue' | 'gray' }) {
  const fill = color === 'blue' ? '#2563EB' : '#9CA3AF';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        d="M12.7252 4.1502L9.2752 0.750195C9.0752 0.550195 8.8002 0.450195 8.5252 0.450195H2.5252C1.6752 0.450195 0.950195 1.1502 0.950195 2.0252V14.0252C0.950195 14.8752 1.6502 15.6002 2.5252 15.6002H11.4502C12.3002 15.6002 13.0252 14.9002 13.0252 14.0252V4.9002C13.0252 4.6252 12.9252 4.3502 12.7252 4.1502ZM9.3002 2.3502L11.1752 4.2002H9.3002V2.3502ZM11.4752 14.4502H2.5252C2.2752 14.4502 2.0752 14.2502 2.0752 14.0002V2.0002C2.0752 1.7502 2.2752 1.5502 2.5252 1.5502H8.1752V4.7502C8.1752 5.0502 8.4252 5.3252 8.7502 5.3252H11.9252V14.0002C11.9002 14.2502 11.7002 14.4502 11.4752 14.4502Z"
        fill={fill}
      />
      <path
        d="M7.8001 6.60039C7.5751 6.37539 7.2251 6.37539 7.0001 6.60039C6.7751 6.82539 6.7751 7.17539 7.0001 7.40039L8.5001 8.92539H4.1751C3.8751 8.92539 3.6001 9.17539 3.6001 9.50039C3.6001 9.82539 3.8501 10.0754 4.1751 10.0754H8.5001L7.0001 11.6004C6.7751 11.8254 6.7751 12.1754 7.0001 12.4004C7.1001 12.5004 7.2501 12.5504 7.4001 12.5504C7.5501 12.5504 7.7001 12.5004 7.8001 12.3754L10.2501 9.90039C10.4751 9.67539 10.4751 9.32539 10.2501 9.10039L7.8001 6.60039Z"
        fill={fill}
      />
    </svg>
  );
}
